const url =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://us-central1-handypass-production.cloudfunctions.net/app'
    : 'https://us-central1-handypass-dev.cloudfunctions.net/app';

export function urlQrCode(value){
  return `${url}/generate-qr?text=${value}&options[width]=300&options[margin]=1`
}